import { 
  SET_REGIONS_LOADING, 
  SET_REGIONS_DATA
} from "./types";
import { api } from "../App";

export const getRegions = () => async (dispatch) => {
  try {
    dispatch({ type: SET_REGIONS_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/regions');
    dispatch({ type: SET_REGIONS_DATA, payload: data.regions || data });
  } catch (ERR) {
    console.error('Ошибка при загрузке регионов:', ERR);
  } finally {
    dispatch({ type: SET_REGIONS_LOADING, payload: false });
  }
}

